import React, {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import ProductList from "../../components/order/ProductList";
import {fetchCustomer, fetchOrderById, updateOrder} from "../../store/order-slice";
import Cart from "../../components/order/Cart";
import {clearCart} from "../../store/cart-slice";
import {fetchProducts} from "../../store/product-slice";

const OrderEdit = () => {
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();

    const {
        items,
        updateStatus,
        fetchByIdStatus,
    } = useSelector(state => state.order);

    const userRole = useSelector((state) => state.auth.selectedRole);

    const orderId = params.orderId;

    const formSubmitHandler = (data) => {
        dispatch(updateOrder({
            ...userRole,
            data,
            orderId: orderId
        }));
    }

    const numberSelectHandler = (phone) => {
        dispatch(fetchCustomer({
            ...userRole,
            phone,
        }));
    }

    useEffect(() => {
        if (updateStatus === "success") {
            navigator("../../");
        }
        dispatch(clearCart())
    }, [dispatch, updateStatus, navigator]);

    useEffect(() => {
        if (orderId) {
            dispatch(fetchOrderById({...userRole, orderId: orderId}));
        }
    }, [orderId, dispatch, userRole]);


    useEffect(() => {
        dispatch(fetchProducts({...userRole, orderPage: true, orderId: orderId}));
    }, [dispatch, userRole, orderId]);

    const editableItem = items.find(item => item.id === orderId);

    return (
        <>
            <SubHeader title="Edit Order" sticky={true}>
                <Button to="../../" className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            {fetchByIdStatus === "loading" && <p>Loading...</p>}
            {fetchByIdStatus === "failed" && <h6 className="text-danger">Failed to fetch order details.</h6>}
            {fetchByIdStatus === "success" && (
                <div className="row gx-6">
                    <div className="col-md-6 col-xl-8">
                        <ProductList editableItem={editableItem} isEditable={true}/>
                    </div>
                    <div className="col-md-6 col-xl-4">
                        <Cart onSubmit={formSubmitHandler}
                              onNumberSelect={numberSelectHandler}
                              isEditable={true}
                              editableItem={editableItem}/>
                    </div>
                </div>
            )}
        </>
    );

}
export default OrderEdit;
